import { makeStyles, tokens } from '@fluentui/react-components';
import { px } from '@this/app-shared/dist/tools/styles.js';

export const useStyles = makeStyles({
    triggerButton: {
        display: 'flex',
        gap: tokens.spacingVerticalS,
        paddingInline: px(0),
        minWidth: px(0),
        fontWeight: tokens.fontWeightRegular,
    },
    isFiltered: {
        color: tokens.colorBrandForeground1,
    },
    sortingButton: {
        alignSelf: 'center',
        marginLeft: tokens.spacingVerticalXS,
        width: tokens.spacingHorizontalXL,
        height: tokens.spacingHorizontalXL,
        minWidth: px(0),
        minHeight: px(0),
        aspectRatio: '1 / 1',
    },
    sortingButtonIcon: {
        fontSize: px(14),
    },
});
